import { listSilobagsService, SilobagListFilter } from '@siloreal:shared:api/service/silobag/silobag-list';
import * as UI from '@siloreal:shared:ui';
import { useSilobagListContext } from '../../../context';
import { TABLE_INTERACTIONS } from '../interactions';
import { toSilobagListContract } from '../service/adapter';
import { TABLE_COLUMNS, TABLE_PINNED_COLUMNS } from '../table-columns';
import { TABLE_FILTERS } from '../table-filters';

const implicitFilters: SilobagListFilter = {
  active: false,
  silobag_data_status_id: 1,
};

const TABLE_ROW_STYLE_VARIANT: UI.TableProps['getRowStyleVariant'] = () => 'basic';

export function ExplorerClosedSilobag() {
  const {
    organization: { current: organizationId },
    async: {
      list: { update },
      summary: {
        trigger: triggerSummary,
        loading: { start: startSummaryLoading, stop: stopSummaryLoading },
      },
    },
  } = useSilobagListContext();

  return (
    <UI.collection.explorer
      service={{
        fn: listSilobagsService,
        key: ['silopro-vrr-list', implicitFilters, organizationId],
        adapter: (state) => toSilobagListContract(state, { implicitFilters }),
        callback: {
          onTrigger: startSummaryLoading,
          onSuccess: (result, state) => {
            update(result.original);
            triggerSummary(toSilobagListContract(state, { implicitFilters }));
          },
          onError: stopSummaryLoading,
          dataAccess: (data) => data.data as UI.TableProps['rows'],
          rowCountAccess: (data) => data.total,
        },
      }}
      columns={TABLE_COLUMNS.SILOBAG.CLOSED}
      headerAction={TABLE_INTERACTIONS.SILOBAG.CLOSED}
      pinnedColumns={TABLE_PINNED_COLUMNS}
      getRowStyleVariant={TABLE_ROW_STYLE_VARIANT}
      searchbar
      tidPrefix="silopro-vrr-list"
    >
      {TABLE_FILTERS.SILOBAG.CLOSED}
    </UI.collection.explorer>
  );
}
